import {
  DialogSurface,
  Dialog,
  DialogBody,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Button,
  TabList,
  Tab,
  DataGrid,
  DataGridRow,
  DataGridHeaderCell,
  DataGridHeader,
  DataGridBody,
  DataGridCell,
  Label,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Dropdown,
  Option,
  Input,
  MessageBar,
  DialogActions,
  Field,
} from "@fluentui/react-components";
import {
  AddFilled,
  DismissRegular,
  PersonAddRegular,
} from "@fluentui/react-icons";
import i18n from "i18next";
import { useEffect, useState } from "react";
import { MyColleaguesColumns } from "./MyColleaguesColumns";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import { ITeamMemberDto } from "../../../Models/ITeamMemberDto";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { ITeamDto } from "../../../Models/ITeamDto";
import { isTouchDevice } from "../../../helpers/helperMethods";

interface IDialogAddColleagueToTeam {
  selectedTeam?: ITeamDto;
  onInvited(): void;
  manualInviteInfos(item: IInviteInfos): void;
}

interface IInviteInfos {
  email: string;
  name: string;
  anrede: string;
}

function DialogAddColleagueToTeam(props: IDialogAddColleagueToTeam) {
  const [nameError, setNameError] = useState<boolean>(false);
  const [currentSelectedSalutation, setCurrentSelectedSalutation] =
    useState<string>("");
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [currentEmailValue, setCurrentEmailValue] = useState<string>("");
  const [currentNameValue, setCurrentNameValue] = useState<string>("");
  const [myColleagues, setMyColleagues] = useState<IAppUserDto[]>([]);
  const [currentTeamMember, setCurrentTeamMember] = useState<string[]>();
  const [selectedTab, setSelectedTab] = useState<string>(
    i18n.t<string>("myColleagues"),
  );
  const [emailError, setEmailError] = useState<boolean>(false);
  const emailRegEx = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
  const [showInviteSucces, setShowInviteSucces] = useState<boolean>(false);
  const CheckValidEMailBoolean = (value: string): boolean => {
    return emailRegEx.test(value) ? true : false;
  };
  const [hover, setHover] = useState<string>("");
  useEffect(() => {
    if (showInviteSucces == true) {
      setTimeout(() => setShowInviteSucces(false), 7000);
    }
  }, [showInviteSucces]);
  function getMyColleagues() {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/teams/GetMyColleagues?teamId=${props.selectedTeam?.teamId}`,
      )
      .then((result) => {
        let colleagues = result;
        if (currentTeamMember != undefined) {
          colleagues = colleagues.map((item: IAppUserDto) => {
            if (!currentTeamMember?.includes(item.id)) {
              return item;
            }
          });
          setMyColleagues(colleagues);
        }
      });
  }
  function setColleagueInvited(colleague: IAppUserDto) {
    fetchWrapper
      .postWithAuth(baseUrl + "/api/teams/AddInvited", {
        teamGuid: props.selectedTeam?.teamId,
        teamName: props.selectedTeam?.teamname,
        email: colleague.email,
        name: colleague.vorname,
        anrede: colleague.anrede,
      })
      .then((result) => {
        getMyColleagues();
        props.onInvited();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const anreden = [i18n.t<string>("herr"), i18n.t<string>("frau")];

  useEffect(() => {
    if (myColleagues.length == 0) {
      setDialogOpen(false);
    }
  }, [myColleagues.length]);

  useEffect(() => {
    let teamMember = props.selectedTeam?.members.map((item) => {
      return item.id;
    });
    setCurrentTeamMember(teamMember);
  }, [props.selectedTeam]);

  useEffect(() => {
    getMyColleagues();
  }, [currentTeamMember]);

  const columns = MyColleaguesColumns({
    onSelectMember: (member) => {
      setColleagueInvited(member);
      getMyColleagues();
      setShowInviteSucces(true);
    },
    hover: "",
  });

  return (
    <Dialog open={dialogOpen}>
      <Button
        icon={<PersonAddRegular />}
        appearance="transparent"
        onClick={() => {
          setDialogOpen(true);
        }}
      >
        {i18n.t<string>("addMember")}
      </Button>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            <div
              style={{
                display: "flex",
                alignContent: "center",
                justifyContent: "space-between",
              }}
            >
              {i18n.t<string>("addMember")}
              <Button
                onClick={() => {
                  setDialogOpen(false);
                }}
                appearance="transparent"
                icon={<DismissRegular />}
              ></Button>
            </div>
          </DialogTitle>
          <DialogContent>
            {i18n.t<string>("addTeamMemberText")}

            <TabList
              onTabSelect={(ev, data) => {
                if (typeof data.value == "string") {
                  setSelectedTab(data.value);
                }
              }}
              selectedValue={selectedTab}
            >
              <Tab value={i18n.t<string>("myColleagues")}>
                {i18n.t<string>("myColleagues")}
              </Tab>
              <Tab value={i18n.t<string>("inviteByEMail")}>
                {i18n.t<string>("inviteByEMail")}
              </Tab>
            </TabList>
            {myColleagues.length > 0 &&
              selectedTab == i18n.t<string>("myColleagues") && (
                <DataGrid columns={columns} items={myColleagues}>
                  <DataGridHeader>
                    <DataGridRow>
                      {({ renderHeaderCell }) => (
                        <DataGridHeaderCell>
                          {renderHeaderCell()}
                        </DataGridHeaderCell>
                      )}
                    </DataGridRow>
                  </DataGridHeader>
                  <DataGridBody<IAppUserDto>>
                    {({ item, rowId }) => (
                      <DataGridRow<IAppUserDto>
                        key={rowId}
                        onMouseEnter={() => {
                          if (isTouchDevice() == false) {
                            setHover(item.id);
                          }
                        }}
                        onMouseLeave={() => {
                          setHover("");
                        }}
                      >
                        {({ renderCell }) => (
                          <DataGridCell>{renderCell(item)}</DataGridCell>
                        )}
                      </DataGridRow>
                    )}
                  </DataGridBody>
                </DataGrid>
              )}
            {myColleagues.length == 0 &&
              selectedTab == i18n.t<string>("myColleagues") && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontSize: "x-large",
                    marginTop: "10px",
                  }}
                >
                  {i18n.t<string>("noItemsFound")}
                  <Button
                    onClick={() =>
                      setSelectedTab(i18n.t<string>("inviteByEMail"))
                    }
                    style={{ marginTop: "15px" }}
                    appearance="primary"
                  >
                    {i18n.t<string>("inviteByEMail")}
                  </Button>
                </div>
              )}
            {selectedTab == i18n.t<string>("inviteByEMail") && (
              <div>
                <Field
                  style={{ width: "100%", marginBottom: "2px" }}
                  label={"Email"}
                  validationMessage={
                    emailError ? i18n.t<string>("enterValidEMail") : ""
                  }
                >
                  <Input
                    type="email"
                    onBlur={() => {
                      if (!CheckValidEMailBoolean(currentEmailValue)) {
                        setEmailError(true);
                      }
                    }}
                    onChange={(ev, data) => {
                      setCurrentEmailValue(data.value);
                      if (CheckValidEMailBoolean(data.value)) {
                        setEmailError(false);
                      }
                    }}
                  ></Input>
                </Field>
                <Field
                  label={i18n.t<string>("anrede")}
                  style={{ width: "100%" }}
                >
                  <Dropdown
                    defaultSelectedOptions={[anreden[0]]}
                    defaultValue={anreden[0]}
                  >
                    {anreden.map((salutation) => {
                      return (
                        <Option
                          onClick={() => {
                            setCurrentSelectedSalutation(salutation);
                          }}
                        >
                          {salutation}
                        </Option>
                      );
                    })}
                  </Dropdown>
                </Field>
                <Field
                  label={"Name"}
                  validationMessage={
                    nameError ? i18n.t<string>("pleaseAddName") : ""
                  }
                  style={{ width: "100%" }}
                >
                  <Input
                    onBlur={() => {
                      if (currentNameValue.length < 1) {
                        setNameError(true);
                      }
                    }}
                    type="text"
                    onChange={(ev, data) => {
                      setCurrentNameValue(data.value);
                      if (data.value.length > 0) {
                        setNameError(false);
                      }
                    }}
                  ></Input>
                </Field>
              </div>
            )}

            {showInviteSucces && (
              <MessageBar intent="success">
                {i18n.t<string>("memberInvited")}
              </MessageBar>
            )}
          </DialogContent>
          {selectedTab == i18n.t<string>("inviteByEMail") && (
            <DialogActions>
              <Button
                style={{ marginLeft: "5px" }}
                appearance={
                  currentEmailValue && currentNameValue ? "primary" : undefined
                }
                disabled={
                  CheckValidEMailBoolean(currentEmailValue) &&
                  currentNameValue.length > 0
                    ? false
                    : true
                }
                onClick={() => {
                  var infos: IInviteInfos = {
                    email: currentEmailValue,
                    name: currentNameValue,
                    anrede: currentSelectedSalutation,
                  };
                  props.manualInviteInfos(infos);
                  props.onInvited();
                  setDialogOpen(false);
                  setShowInviteSucces(true);
                }}
              >
                {i18n.t<string>("addMember")}
              </Button>
              <Button
                onClick={() => {
                  setDialogOpen(false);
                  setEmailError(false);
                  setNameError(false);
                }}
              >
                {i18n.t<string>("cancel")}
              </Button>
            </DialogActions>
          )}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogAddColleagueToTeam;
